"use client";

import { useLayoutEffect, useState, type RefObject } from "react";
import type {
  ScrollHintState,
  TimelineViewportState,
} from "./timeline-root-types";
import {
  EMPTY_SCROLL_HINT_STATE,
  EMPTY_VIEWPORT_STATE,
} from "./timeline-scroll-selectors";
import { useTimelineScrollUiEvents } from "./useTimelineScrollUiEvents";
import { useTimelineScrollUiUpdater } from "./useTimelineScrollUiUpdater";

export interface UseTimelineScrollUiStateInput {
  innerRef: RefObject<HTMLDivElement | null>;
  layoutContentWidth: number | undefined;
  scrollContainerRef: RefObject<HTMLDivElement | null>;
}

export interface TimelineScrollUiState {
  centeredPeriodIndex: number;
  scrollHintState: ScrollHintState;
  viewportState: TimelineViewportState;
}

export function useTimelineScrollUiState({
  innerRef,
  layoutContentWidth,
  scrollContainerRef,
}: UseTimelineScrollUiStateInput): TimelineScrollUiState {
  const [scrollHintState, setScrollHintState] = useState<ScrollHintState>(
    EMPTY_SCROLL_HINT_STATE,
  );
  const [centeredPeriodIndex, setCenteredPeriodIndex] = useState<number>(0);
  const [viewportState, setViewportState] = useState<TimelineViewportState>(
    EMPTY_VIEWPORT_STATE,
  );

  const updateScrollUi = useTimelineScrollUiUpdater({
    innerRef,
    scrollContainerRef,
    setCenteredPeriodIndex,
    setScrollHintState,
    setViewportState,
  });

  useLayoutEffect(() => {
    updateScrollUi();
  }, [layoutContentWidth, updateScrollUi]);

  useTimelineScrollUiEvents({
    scrollContainerRef,
    updateScrollUi,
  });

  return {
    centeredPeriodIndex,
    scrollHintState,
    viewportState,
  };
}
